'use client';

import cn from 'classnames';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { Wrapper } from '@/components/Wrapper';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import { CarouselBase } from '../../CarouselBase';
import { DirectionSlide } from '../../CarouselBase/slides/DirectionSlide';
import s from './DirectionCarousel.module.scss';

interface SlideProps {
  image?: string;
  link: string;
  badge?: {
    name: string;
    position: string;
  };
  title: string;
  description: string;
}

interface DirectionCarouselProps {
  slides: SlideProps[];
}

const DirectionCarousel = ({ slides }: DirectionCarouselProps) => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  return (
    <section className={cn(s.root)}>
      <Wrapper>
        <div className={s.subtitle}>вакансии</div>
        <h2 className={s.title}>
          Начни свой путь в Cloud.ru <br />
          в одном из направлений
        </h2>
      </Wrapper>
      <div className={s.carouselWrapper}>
        <CarouselBase
          slidesCount={slides.length}
          withNavigation={!!windowWidth && windowWidth > MD}
          withPagination={!!windowWidth && windowWidth <= MD}
          carouselClassName={s.carousel}
          rewind
          navigationClassName={s.navigation}
          slideClassName={s.slide}
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            637: {
              slidesPerView: 2.2,
            },
          }}
          analyticsName="direction-carousel"
        >
          {slides.map(({ title, badge, image, link, description }, index) => {
            return (
              <DirectionSlide
                title={title}
                badge={badge}
                image={image}
                link={link}
                description={description}
                key={index}
                className={s.slideInner}
              />
            );
          })}
        </CarouselBase>
      </div>
      <Wrapper className={s.buttonWrapper}>
        <Link withButton href="/vacancies" className={cn(s.link, 'link')}>
          <Button
            className={s.button}
            analyticsOptions={{
              action: 'click',
              clickZone: 'body',
              clickElement: 'buttonclick',
              clickContent: 'Смотреть все вакансии',
              uniqueId: `direction-carousel-Смотреть все вакансии`,
              transitionType: 'inside-link',
              clickZoneCategory: 'site-body',
            }}
          >
            Смотреть все вакансии
          </Button>
        </Link>
      </Wrapper>
    </section>
  );
};

export { DirectionCarousel };
